"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var bold = _ref.bold,
      light = _ref.light;
  if (bold) return 700;
  if (light) return 300;
  return 400;
};